import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { useMembers } from "src/scenes/teams/members-provider";
import fetchStatus from "src/utils/api/fetch-status";

const AddToPlanTextfield = ({ usersToAdd, setUsersToAdd, clearError }) => {
    const [inputValue, setInputValue] = React.useState("");

    const orgMembersApi = useMembers();
    const processInputValues = (input) => {
        const newUsers = input
            .split(/[,;\s]+/)
            .map((email) => email.trim())
            .filter((email) => email.length > 0 && !/^\s*$/.test(email));
        setUsersToAdd((prev) => [...prev, ...newUsers]);
        setInputValue("");
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter" || event.key === " " || event.key === ";" || event.key === ",") {
            event.preventDefault();
            processInputValues(inputValue);
        }
    };

    const handlePaste = (event) => {
        event.preventDefault();
        const pasteData = event.clipboardData.getData("text");
        processInputValues(pasteData);
    };
    if (orgMembersApi && orgMembersApi.status !== "SUCCESS") return null;
    return (
        <Stack spacing={3} sx={{ width: 500 }}>
            <Autocomplete
                value={usersToAdd}
                onChange={(event, newValue) => {
                    setUsersToAdd(newValue);
                }}
                inputValue={inputValue}
                groupBy={(option) => option.hasSubscription}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                loading={
                    orgMembersApi.status !== fetchStatus.SUCCESS &&
                    orgMembersApi.status !== fetchStatus.ERROR
                }
                multiple
                freeSolo
                options={
                    orgMembersApi &&
                    orgMembersApi.data &&
                    orgMembersApi.data.users &&
                    orgMembersApi.data.users.filter((option) => !option.hasSubscription)
                }
                id="tags-outlined"
                getOptionLabel={(option) => option.displayName || option.email || `${option} *`}
                filterSelectedOptions
                renderInput={(params) => (
                    <TextField
                        {...params}
                        onClick={() => clearError()}
                        onKeyDown={handleKeyDown}
                        onPaste={handlePaste}
                        label="Users To Add"
                        placeholder="Start typing user name or email"
                    />
                )}
            />
        </Stack>
    );
};

export default AddToPlanTextfield;
